var exports = {
  "kL": "x620889e6--916523--container",
  "cq": "x620889e6--916523--phone-button",
  "P8": "x620889e6--916523--book-coworking-button",
};

module.exports = exports;
